module.exports = __webpack_public_path__ + "static/web_image-4686b77ff21a8d2a16096734451aff38.jpg";